import { useState } from 'react';

const testimonials = [
  {
    quote: "I redesigned my entire living room with pieces from Maison Atelier, and the transformation is breathtaking. The quality surpasses anything I've encountered elsewhere — and the personal service made the process genuinely enjoyable.",
    author: 'Sophia Marchetti',
    role: 'Interior Designer, Milan',
    image: 'https://public.readdy.ai/ai/img_res/711389efe3cae350719561217a9f1898.jpg',
  },
  {
    quote: "The dining table we purchased became the heart of our home. Friends always comment on its beauty. Five years on, it looks just as stunning as when it was delivered. Truly investment-worthy furniture.",
    author: 'James Holloway',
    role: 'Architect, London',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20dining%20room%20interior%20solid%20wood%20dining%20table%20elegant%20chairs%20warm%20lighting%20flowers%20centerpiece%20luxury%20home%20editorial%20photography&width=700&height=600&seq=t2&orientation=portrait',
  },
  {
    quote: "From the moment I walked into the showroom to the final delivery, every step felt curated and luxurious. The Crest chair I chose is the perfect balance of comfort and artistry. I couldn't be happier.",
    author: 'Élise Fontaine',
    role: 'Art Director, Paris',
    image: 'https://readdy.ai/api/search-image?query=cozy%20reading%20nook%20with%20elegant%20accent%20chair%20warm%20light%20bookshelves%20soft%20rug%20linen%20cushion%20luxury%20interior%20editorial%20photography&width=700&height=600&seq=t3&orientation=portrait',
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);

  const t = testimonials[active];

  return (
    <section className="w-full bg-[#faf8f5] py-24 px-6 md:px-16">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <p className="text-xs uppercase tracking-[0.3em] text-[#8B6348] mb-3 font-medium text-center">Client Stories</p>
        <h2 className="text-4xl md:text-5xl font-bold text-[#2c2420] text-center mb-16" style={{ fontFamily: "'Playfair Display', serif" }}>
          What Our Clients Say
        </h2>

        {/* Main content */}
        <div className="flex flex-col lg:flex-row gap-12 items-center">
          {/* Image */}
          <div className="w-full lg:w-[420px] flex-shrink-0 h-[400px] rounded-3xl overflow-hidden">
            <img
              src={t.image}
              alt={`${t.author} testimonial`}
              className="w-full h-full object-cover object-top transition-opacity duration-500"
              key={active}
            />
          </div>

          {/* Content */}
          <div className="flex-1">
            <i className="ri-double-quotes-l text-5xl text-[#d4b896] mb-6 block" />
            <p
              className="text-[#3a3228] text-xl leading-relaxed mb-8 italic"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              {t.quote}
            </p>
            <div className="flex items-center gap-4 mb-10">
              <div className="w-px h-10 bg-[#8B6348]" />
              <div>
                <p className="text-[#2c2420] font-semibold text-sm">{t.author}</p>
                <p className="text-stone-400 text-xs mt-0.5">{t.role}</p>
              </div>
            </div>

            {/* Controls */}
            <div className="flex items-center gap-3">
              <button
                onClick={() => setActive((active - 1 + testimonials.length) % testimonials.length)}
                className="w-10 h-10 flex items-center justify-center rounded-full border border-stone-300 text-stone-500 hover:border-[#8B6348] hover:text-[#8B6348] transition-colors cursor-pointer"
                aria-label="Previous"
              >
                <i className="ri-arrow-left-line" />
              </button>
              <button
                onClick={() => setActive((active + 1) % testimonials.length)}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-[#2c2420] text-white hover:bg-[#8B6348] transition-colors cursor-pointer"
                aria-label="Next"
              >
                <i className="ri-arrow-right-line" />
              </button>
              <div className="flex gap-2 ml-2">
                {testimonials.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setActive(i)}
                    className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
                      i === active ? 'w-6 bg-[#8B6348]' : 'w-1.5 bg-stone-300'
                    }`}
                    aria-label={`Testimonial ${i + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
